import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import lastUpdated from '../../../../utils/lastUpdated';
import { getRandomColor } from '../../utils';
import daysLeft from '../../../../utils/daysLeft';
import { getLocalDateTime } from '../../../../utils/utils';
import {
  Wrap,
  Header,
  Title,
  LastUpdate,
  ListHeader,
  Project,
  ProjectInfo,
  ProjectTitle,
  ProjectSubtitle,
  ProjectDaysLeft,
  HTask,
  HDays,
  Projects,
} from './styles';

const TaskTimeLine = ({ priorityTasks }) => {
  return (
    <Wrap>
      <Header>
        <Title>Task Timeline</Title>
        <LastUpdate>{lastUpdated()}</LastUpdate>
      </Header>
      <ListHeader>
        <HTask>Task</HTask>
        <HDays>Days left</HDays>
      </ListHeader>
      <Projects>
        {priorityTasks.map((task, index) => {
          if (task.status !== 'CPL') {
            return (
              <Project
                key={`${task.project.id}${index}`}
                color={getRandomColor()}
                days={task.days}
              >
                <ProjectInfo>
                  <ProjectTitle>
                    <Link
                      id="spectrum-link"
                      to={{
                        pathname: `/task/${task.ID}`,
                        state: {
                          id: task.ID,
                        },
                      }}
                    >
                      {task.name}
                    </Link>
                  </ProjectTitle>
                  <ProjectSubtitle>
                    Project: {task.project.name}
                  </ProjectSubtitle>
                </ProjectInfo>
                <ProjectDaysLeft>
                  {daysLeft(getLocalDateTime(task.plannedCompletionDate, true))}
                </ProjectDaysLeft>
              </Project>
            );
          }
          return '';
        })}
      </Projects>
    </Wrap>
  );
};

TaskTimeLine.propTypes = {
  priorityTasks: PropTypes.arrayOf(
    PropTypes.shape({
      project: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
      name: PropTypes.string,
      days: PropTypes.number,
    }),
  ),
};

TaskTimeLine.defaultProps = {
  priorityTasks: {
    project: {
      id: '',
      name: '',
    },
    name: '',
    days: '',
  },
};

export default TaskTimeLine;
